var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__clip0_4349_106)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.48 19.25H7.52a4.774 4.774 0 01-4.769-4.77V7.52A4.774 4.774 0 017.519 2.75h6.962a4.774 4.774 0 014.769 4.769v6.962a4.775 4.775 0 01-4.77 4.769zM7.52 4.41a3.113 3.113 0 00-3.11 3.11v6.96a3.113 3.113 0 003.11 3.11h6.962a3.113 3.113 0 003.11-3.11V7.52a3.113 3.113 0 00-3.11-3.11H7.519z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.176a4.176 4.176 0 110-8.352 4.176 4.176 0 010 8.352zm0-6.965a2.789 2.789 0 100 5.577 2.789 2.789 0 000-5.577z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.636 7.513a.973.973 0 10-.756-1.794.973.973 0 00.756 1.794z",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__clip0_4349_106"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.75 2.75)",
    d: "M0 0h16.5v16.5H0z"
  })))));
}
export default SvgInstagram;